export default __webpack_public_path__ + "static/media/ErrorImage.5ce52462.svg";